import React, { useState } from 'react';
import { IsCustomMaxWidth, IsCustomMinWidth, IsMobileMaxWidth } from 'core/util/WindowSize';
import Colors from 'enums/Colors';
import Slider from 'react-slick';
import styled from 'styled-components';
import { ListCards } from 'pages/solucoes/components/solucoes/MultiSolucoes';
import { CardOfferedSolutionsSimples } from 'pages/solucoes/components/solucoes/OfferedSolutions';

interface IArrowButton {
    next: boolean;
}
const Styled = {
    Container: styled.div`
        display: flex;
        height: 850px;
        background-color: #f5f5f5;
        flex-direction: column;
        gap: 24px;
        padding-top: 74px;
        padding-left: 280px;

        @media screen and (max-width: 1600px) {
            padding-left: 80px;
        }
        @media screen and (max-width: 500px) {
            padding-left: 20px;
        }
    `,

    Title: styled.h1`
        font-family: 'Barlow';
        font-weight: 700;
        font-size: 40px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        text-transform: uppercase;
        color: ${Colors.Blue};
    `,

    Carrousel: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        height: 450px;
        max-width: 80%;
        margin: 40px;

        @media screen and (max-width: 600px) {
            margin: 10px;
            height: 520px;
        }
    `,

    CarouselCardContainer: styled.div<{ preview?: boolean }>`
        width: 100%;
        margin-top: 90px;
        padding: 10px;

        .slick-slide {
            display: flex;
            justify-content: center;
            align-items: start;
        }

        .slick-dots {
            li {
                button::before {
                    color: ${({ preview }) => (preview ? Colors.Blue : Colors.Yellow)}; /* Define a cor das dots */
                    font-size: 20px;
                }
                &.slick-active {
                    button::before {
                        color: ${({ preview }) => (preview ? Colors.Blue : Colors.Yellow)}; /* Define a cor para a dot selecionada */
                    }
                }
            }
        }

        @media screen and (max-width: 800px) {
            padding: 0;
            .slick-slide {
                justify-content: center;
                align-items: center;
            }
        }
    `,

    ArrowButton: styled.div<IArrowButton>`
        cursor: pointer;
        width: 56px;
        height: 56px;
        outline: none;
        border: none;
        position: absolute;
        z-index: 8;
        top: 45%;
        right: ${props => (props.next ? '0%' : '')};
        left: ${props => (props.next ? '100%' : '-3%')};

        @media screen and (max-width: 1920px) {
            left: ${props => (props.next ? '100%' : '-4%')};
        }
        @media screen and (max-width: 1500px) {
            left: ${props => (props.next ? '98%' : '-4%')};
        }
        @media screen and (max-width: 1280px) {
            left: ${props => (props.next ? '100%' : '-5%')};
        }

        @media screen and (max-width: 600px) {
            left: ${props => (props.next ? '100%' : '-5%')};
            height: 29px;
            width: 26px;
        }
    `,

    SvgIcon: styled.svg.attrs({
        version: '1.1',
        xmlns: 'http://www.w3.org/2000/svg',
        xmlnsXlink: 'http://www.w3.org/1999/xlink',
    })`
        height: 59px;
        width: 56px;
        fill: ${Colors.Yellow};

        &:hover {
            fill: ${Colors.Yellow};
        }

        @media screen and (max-width: 600px) {
            width: 26px;
            height: 29px;
        }
    `,
};

//Outros Conteudos da Humane
const FiveSession = () => {
    const isMax1320 = IsCustomMaxWidth(1320);
    const isMax980 = IsCustomMaxWidth(980);


    const IsMobile = () => {
        return IsMobileMaxWidth();
    };

    const NextArrow = ({ ...props }: any) => {
        return (
            <Styled.ArrowButton next={true} onClick={props.onClick}>
                <Styled.SvgIcon>
                    {IsCustomMinWidth(600) && <circle r="28" transform="matrix(-1 0 0 1 28 28)" stroke={Colors.Yellow} />}
                    <path
                        d="M0.472656 26.5214L11.1593 15.0974L0.472656 3.6734L3.76266 0.164062L17.7627 15.0974L3.76266 30.0307L0.472656 26.5214Z"
                        transform={IsCustomMinWidth(600) ? 'translate(18, 12)' : ''}
                        fill={Colors.Blue}
                        stroke={Colors.Blue}
                    />
                </Styled.SvgIcon>
            </Styled.ArrowButton>
        );
    };

    const PreviousArrow = ({ ...props }: any) => {
        return (
            <Styled.ArrowButton next={false} onClick={props.onClick}>
                <Styled.SvgIcon>
                    {IsCustomMinWidth(600) && <circle r="28" transform="matrix(1 1.74846e-07 1.74846e-07 -1 28 28)" stroke={Colors.Yellow} />}
                    <path
                        d="M17.9931 26.5214L7.30646 15.0974L17.9931 3.6734L14.7031 0.164062L0.703125 15.0974L14.7031 30.0307L17.9931 26.5214Z"
                        transform={IsCustomMinWidth(600) ? 'translate(15, 12)' : ''}
                        fill={Colors.Blue}
                        stroke={Colors.Blue}
                    />
                </Styled.SvgIcon>
            </Styled.ArrowButton>
        );
    };

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: isMax980 ? 1 : isMax1320 ? 2 : 3,
        slidesToScroll: 2,

        nextArrow: <NextArrow />,
        prevArrow: <PreviousArrow />,
    };

    return (
        <Styled.Container>
            <Styled.Title>Outros conteúdos da humane</Styled.Title>
            <Styled.Carrousel>
                <Styled.CarouselCardContainer>
                    <Slider autoplay autoplaySpeed={5000} {...settings}>
                        {ListCards.map((card, index) => (
                            <CardOfferedSolutionsSimples key={index} card={card} isMobile={IsMobile()} />
                        ))}
                    </Slider>
                </Styled.CarouselCardContainer>
            </Styled.Carrousel>
        </Styled.Container>
    );
};

export default FiveSession;
